import clsx from "clsx";
import type { InputHTMLAttributes } from "react";
import { generateKey } from "~/utils/RandomKeyGenerator";
import Styles from "./Switcher.module.scss";

type Props = InputHTMLAttributes<HTMLInputElement> & {
	className?: string;
	disabled?: boolean;
};

export function Switcher({
	className = "",
	disabled = false,

	...props
}: Props) {
	const key = generateKey();
	return (
		<div className={clsx(Styles.Switcher, disabled ? Styles.Disabled : "")}>
			<input
				className={clsx(className, Styles.Input)}
				disabled={disabled}
				id={`switcher_${key}`}
				type="checkbox"
				{...props}
			/>
			<label className={Styles.Slider} htmlFor={`switcher_${key}`} />
		</div>
	);
}
